module.exports = __webpack_public_path__ + "static/img/30001 (3).c20685b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30001 (3).webp
// module id = giZY
// module chunks = 14